import { ImageRequireSource } from 'react-native'

export const FARM_LOGO_PLACEHOLDER: ImageRequireSource = require('../assets/placeholders/farm-logo.png')
export const FARM_IMAGE_PLACEHOLDER: ImageRequireSource = require('../assets/placeholders/farm.png')
export const PROFILE_IMAGE_PLACEHOLDER: ImageRequireSource = require('../assets/placeholders/farmer.jpg')
export const PRODUCT_IMAGE_PLACEHOLDER: ImageRequireSource = require('../assets/placeholders/product.jpg')
